export function prettyPhone(phoneNumber) {
  return phoneNumber.length !== 10
    ? phoneNumber
    : `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
